<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiTrashCanOutline } from "@mdi/js";
export default {
  name: "MdiTrashCanOutline",
  data() {
    return {
      svgPath: mdiTrashCanOutline,
    };
  },
};
</script>
